export type GuideCategory = {
  readonly id: number;
  readonly name: string;
};

export function createGuideCategory(values: unknown): GuideCategory {
  const { id, name } = values as GuideCategory;

  return {
    id,
    name,
  };
}
